module.exports = __webpack_public_path__ + "static/img/5areaA_1.e3a8bec.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character1/animal/5areaA_1.png
// module id = 810
// module chunks = 1